/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Invitecollaboratorselectrole3Inputs */

const en_settings_collaborators_invitecollaboratorselectrole3 = /** @type {(inputs: Settings_Collaborators_Invitecollaboratorselectrole3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select role`)
};

/**
* | output |
* | --- |
* | "Select role" |
*
* @param {Settings_Collaborators_Invitecollaboratorselectrole3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_invitecollaboratorselectrole3 = /** @type {((inputs?: Settings_Collaborators_Invitecollaboratorselectrole3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Invitecollaboratorselectrole3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_invitecollaboratorselectrole3(inputs)
});
export { settings_collaborators_invitecollaboratorselectrole3 as "settings_collaborators_inviteCollaboratorSelectRole" }